// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CanvasCTAViewMore_wrapper__ivIeY","darkMode":"CanvasCTAViewMore_darkMode__dmBSP"};